import {OldEmitterConfig} from "pixi-particles";

export class ParticleSettings {
    public static readonly confetti: OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.7,
            "end": 0.6,
            "minimumScaleMultiplier": 0.2
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 800,
            "end": 1000,
            "minimumSpeedMultiplier": 0.1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 1,
        "startRotation": {
            "min": 90,
            "max": 70
        },
        "noRotation": false,
        "rotationSpeed": {
            "min": 360,
            "max": 360
        },
        "lifetime": {
            "min": 1,
            "max": 1.2
        },
        "blendMode": "normal",
        "frequency": 0.004,
        "emitterLifetime": -1,
        "maxParticles": 3000,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "rect",
        "spawnRect": {
            "x": 0,
            "y": 0,
            "w": 1680,
            "h": 1
        }
    };
}